import { render, staticRenderFns } from "./addPincodes.vue?vue&type=template&id=17c0fe80"
import script from "./addPincodes.vue?vue&type=script&lang=js"
export * from "./addPincodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports